<template>
  <v-container fluid :class="$style['container']">
    <v-row :class="$style['main']" justify="center" align-content="center">
      <v-col>

        <h1 :class="$style['error']">エラーが発生しました</h1>
        <p :class="$style['description']">
          エラーが発生しました。お手数おかけしますが、<br />
          トップページに戻って最初から操作してください
        </p>

        <v-row :class="$style['button']" justify="center">
            <CustomButton icon="arrowRight" :iconPositionRight="true" :onClick="onBack" label="トップページに戻る" />
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import CustomButton from '@/components/custom-button';

export default {
  components: {
    CustomButton
  },
  data() {
    return {
    }
  },
  props: {
  },
  computed: {
  },
  methods: {
    onBack(){
      this.$router.push({
        path: `/order/index`
      });
    }
  },
  created() {
  }
};
</script>

<style module lang="scss">
  .container.container {
    width: 100%;
    height: 100%;
    padding: 0;
  }

  .main{
    height: 100%;
  }

  h1.error{
    width: 100%;
    margin-top: 50px;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
  }
  .description{
    width: 100%;
    margin-top: 25px;
    font-size: 12px;
    text-align: center;
    line-height: 2em;
  }

  .button{
    margin: 50px 0;
  }
</style>
